import React, { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import * as CronofyElements from 'cronofy-elements'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

interface AvailabilityViewerCallbackNotificationSlot {
  start: string
  end: string
}
interface AvailabilityViewerCallbackNotification {
  type: string
  slot?: AvailabilityViewerCallbackNotificationSlot
}
interface AvailabilityViewerCallback {
  notification: AvailabilityViewerCallbackNotification
}

interface AvailabilityQueryParticipantMember {
  sub: string
}
interface AvailabilityQueryParticipant {
  required: 'all' | number
  members: AvailabilityQueryParticipantMember[]
}

interface AvailabilityQueryQueryPeriod {
  start: string
  end: string
}
interface AvailabilityQueryRequiredDuration {
  minutes: number
}
interface AvailabilityQueryOptions {
  participants: AvailabilityQueryParticipant[]
  query_periods: AvailabilityQueryQueryPeriod[]
  required_duration: AvailabilityQueryRequiredDuration
  include_member_statuses?: boolean
}

interface ConfigOptions {
  start_time?: string
  end_time?: string
  interval?: number
  slot_selection?: 'unrestricted' | 'available'
  mode?: 'confirm' | 'no_confirm' | 'multi_select' | 'free_select'
  allow_expansion?: boolean
  bounds_control?: boolean
}
interface AvailabilityViewerOptions {
  availability_query: AvailabilityQueryOptions
  config: ConfigOptions
  locale?: string
  tzid?: string
}
interface Props {
  elementToken: string
  options: AvailabilityViewerOptions
  onChange: (date: string) => void
}

export const AvailabilityViewer = ({ elementToken, options, onChange }: Props) => {
  const [element, setElement] = useState<typeof CronofyElements.AvailabilityViewer>()

  const callback = ({ notification }: AvailabilityViewerCallback) => {
    if (notification.type === 'slot_selected') {
      const selectedValue = new Date(notification.slot!.start)
      onChange(selectedValue.toISOString())
    }
  }

  const completeOptions = {
    element_token: elementToken,
    data_center: 'de', // TO-DO: make this configurable somewhere
    target_id: 'cronofy-availability-viewer',
    callback,
    ...options,
  }

  useUnsafeEffect(() => {
    if (element) {
      element.update(completeOptions)
    } else {
      setElement(CronofyElements.AvailabilityViewer(completeOptions))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementToken, JSON.stringify(options)])

  return (
    <Box>
      <div id="cronofy-availability-viewer" />
    </Box>
  )
}
